import { setElementValue } from "../lib/utils.js"

class FFQuantity extends HTMLElement {
  DOM: {
    plus: HTMLElement | null
    minus: HTMLElement | null
    input: HTMLInputElement | null
  }
  increment: number
  min: number
  max: number

	constructor(){
		super()
		this.DOM = {
			plus: this.querySelector(".js-plus"),
			minus: this.querySelector(".js-minus"),
			input: this.querySelector(".qty"),
		}
    const increment = this.getAttribute('increment')
    const min = this.getAttribute('min')
    const max = this.getAttribute('max')
		this.increment = increment ? parseInt(increment) : 1
		this.min = min ? parseInt(min) : 0
		this.max = max ? parseInt(max) : 9999
		this.events();
	}

	events(){
		this.DOM.plus?.addEventListener( 'click', this.incrementUp.bind(this) );
		this.DOM.minus?.addEventListener( 'click', this.incrementDown.bind(this) );
		this.DOM.input?.addEventListener( 'input', this.inputChange.bind(this) );
	}

	inputChange(e: Event){
		const target = e.currentTarget
		if( !(target instanceof HTMLInputElement)) return
		const value = target.value ? parseInt(target.value) : 0
		if( value > this.max )
			target.value = String(Math.min(value, this.max))
	}
	
	incrementUp(){
    const value = this.DOM.input?.value || "0"
		const newValue = Math.min( Number( value ) + Number(this.increment), this.max );
    setElementValue(this.DOM.input, newValue)
		const event = new Event("change");
    if( !(this.DOM.input instanceof HTMLInputElement )) return
		this.DOM.input.dispatchEvent(event);
	}
	
	incrementDown(){
    const value = this.DOM.input?.value || "0"
		const newValue = Math.max( Number( value ) - Number(this.increment), this.min );
		setElementValue(this.DOM.input, newValue)
		const event = new Event("change");
    if( !(this.DOM.input instanceof HTMLInputElement )) return
		this.DOM.input.dispatchEvent(event);
	}
};
customElements.define('ff-quantity', FFQuantity);